import LogInputContainer from "../logData/LogInputContainer";

const VracContainer = () => {
  return <LogInputContainer />;
};

export default VracContainer;
